/**
 * Clip styles the video editor can open. The editor drives the vendored reel
 * and quote compositions; `genericCarousel` keeps its own preview surface and
 * is deliberately left alone.
 */
export const EDITOR_CLIP_STYLES = ['reel', 'quote'];

export const isEditorClipStyle = (style: string): boolean => EDITOR_CLIP_STYLES.includes(style);
